/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PurgeQueueRequest
 */
export interface PurgeQueueRequest {
  /**
   *
   * @type {number}
   * @memberof PurgeQueueRequest
   */
  olderThanMinutes: number;
}

/**
 * Check if a given object implements the PurgeQueueRequest interface.
 */
export function instanceOfPurgeQueueRequest(
  value: object,
): value is PurgeQueueRequest {
  if (!("olderThanMinutes" in value) || value["olderThanMinutes"] === undefined)
    return false;
  return true;
}

export function PurgeQueueRequestFromJSON(json: any): PurgeQueueRequest {
  return PurgeQueueRequestFromJSONTyped(json, false);
}

export function PurgeQueueRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PurgeQueueRequest {
  if (json == null) {
    return json;
  }
  return {
    olderThanMinutes: json["olderThanMinutes"],
  };
}

export function PurgeQueueRequestToJSON(json: any): PurgeQueueRequest {
  return PurgeQueueRequestToJSONTyped(json, false);
}

export function PurgeQueueRequestToJSONTyped(
  value?: PurgeQueueRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    olderThanMinutes: value["olderThanMinutes"],
  };
}
